var _defs, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMuscleup(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 840,
    height: 900,
    viewBox: "0 0 42 45",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "g",
    x1: 0,
    y1: 0,
    x2: 1,
    y2: 1
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#C8FF3D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "55%",
    stopColor: "#8CFF2E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#49D96B"
  })))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M 6 0 L 0 6 L 0 38 L 8 44 L 9 20 L 21 28 L 34 20 L 35 45 L 42 39 L 42 5 L 35 3 L 35 8 L 21 18 L 8 9 L 8 2 Z",
    fill: "url(#g)",
    stroke: "none"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMuscleup);
export default __webpack_public_path__ + "static/media/muscleup.245ea7d9592179f5f96db351adac0c4f.svg";
export { ForwardRef as ReactComponent };